import script from "./HowItWorksSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HowItWorksSection.vue?vue&type=script&setup=true&lang=js"

import "./HowItWorksSection.vue?vue&type=style&index=0&id=517b6328&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-517b6328"]])

export default __exports__